import { render } from "./UserHistoryForm.vue?vue&type=template&id=56a46594&scoped=true"
import script from "./UserHistoryForm.vue?vue&type=script&lang=js"
export * from "./UserHistoryForm.vue?vue&type=script&lang=js"

import "./UserHistoryForm.vue?vue&type=style&index=0&id=56a46594&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a46594"]])

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio,QSelect,QInput,QBtn,QImg,QIcon});
